import { render } from "./socialPlatform.vue?vue&type=template&id=b35fce86&scoped=true"
import script from "./socialPlatform.vue?vue&type=script&lang=js"
export * from "./socialPlatform.vue?vue&type=script&lang=js"

import "./socialPlatform.vue?vue&type=style&index=0&id=b35fce86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35fce86"]])

export default __exports__